










import { Component, Vue } from 'vue-property-decorator';
import { StoryUser } from '../StoryUser'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { globalUC } from '../UserCache'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src


@Component({
  name: 'AdminSendSupportText',
  components: { ModalWrapperComponent }
})
export default class AdminSendSupportTextView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // public functions available to the html template

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async showIt() {
    const targetUserId: string = this.$route.query.targetUserId as string
    let fromPhoneNumber: string = this.$route.query.fromPhoneNumber as string
    const incomingMessage: string = this.$route.query.incomingMessage as string

    if (!targetUserId || !fromPhoneNumber || !incomingMessage) {
      utils.toast(this, 'Error', 'Missing parameters')
      return
    }

    // because '+' gets converted to ' '
    fromPhoneNumber = fromPhoneNumber.replace(' ', '+');

    (this.$refs.AdminSendSupportTextComponent as any).show(null, 'md', { targetUserId, fromPhoneNumber, incomingMessage })

  }

  // TODO: call server API (api/phoneNumbers/:id) to get full history of our conversation and show it here
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name);

    const targetUserId: string = this.$route.query.targetUserId as string
    let fromPhoneNumber: string = this.$route.query.fromPhoneNumber as string
    const incomingMessage: string = this.$route.query.incomingMessage as string

    if (!targetUserId || !fromPhoneNumber || !incomingMessage) {
      utils.toast(this, 'Error', 'Missing parameters')
      return
    }

    // because '+' gets converted to ' '
    fromPhoneNumber = fromPhoneNumber.replace(' ', '+');

    // popup
    await this.showIt()

  }

}

